import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getUserTransactions, GetUserTransactionsParams} from '../api';
import {QUERY__USER_TRANSACTIONS} from '../queryKeys';
import {Transaction} from '../types';

export const useGetUserTransactions = <
  SelectedData = GetListOutput<Transaction>,
>(
  params: GetUserTransactionsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__USER_TRANSACTIONS, params],
    queryFn: () => getUserTransactions(params),
    ...options,
  });
};
